import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import NotificationPage from '@/pages/NotificationPage'
import SearchPage from '@/pages/SearchPage'

import { TenantAdminLayout } from '../../layouts/TenantAdminLayout'
import ChatPage from '../../pages/ChatPage'
import NotificationManagerPage from '../../pages/Dispatcher/NotificationManagerPage'
import { Settings } from '../../pages/Dispatcher/Settings'
import { AdminDashboard } from '../../pages/TenantAdmin/components/AdminDashboard'
import { AdminServiceManagement } from '../../pages/TenantAdmin/components/AdminServiceManagement'
import { AdminTeamManagement } from '../../pages/TenantAdmin/components/AdminTeamMenagment'
import { AdminUserManagement } from '../../pages/TenantAdmin/components/AdminUserManagement'
import { AdminWorkGroupPage } from '../../pages/TenantAdmin/components/AdminWorkGroup/AdminWorkGroupPage'
import { AdminWorkGroupManagement } from '../../pages/TenantAdmin/components/AdminWorkGroupManagement'
import UserPage from '../../pages/UserPage/UserPage'
import { UserRoleEnum } from '../../types'

import ProtectedRoute from './ProtectedRoute'
import { EnumGlobalRoutes, EnumTenantAdminRoutes } from './routerConstants'

const TenantAdminRoutes: React.FC = () => (
    <ProtectedRoute allowedRoles={[UserRoleEnum.TENANT_ADMIN]}>
        <Routes>
            <Route element={<TenantAdminLayout />}>
                <Route
                    index
                    element={<AdminDashboard />}
                />
                <Route
                    path={EnumTenantAdminRoutes.TENANT_ADMIN_SERVICE_MANAGEMENT}
                    element={<AdminServiceManagement />}
                />
                <Route
                    path={EnumTenantAdminRoutes.TENANT_ADMIN_USER_MANAGEMENT}
                    element={<AdminUserManagement />}
                />
                <Route
                    path={EnumTenantAdminRoutes.TENANT_ADMIN_TEAM_MANAGEMENT}
                    element={<AdminTeamManagement />}
                />
                <Route
                    path={
                        EnumTenantAdminRoutes.TENANT_ADMIN_WORKGROUP_MANAGEMENT
                    }
                    element={<AdminWorkGroupManagement />}
                />
                <Route
                    path={
                        EnumTenantAdminRoutes.TENANT_ADMIN_WORKGROUP_MANAGEMENT +
                        '/:id'
                    }
                    element={<AdminWorkGroupPage />}
                />
                <Route
                    path={EnumGlobalRoutes.NOTIFICATION}
                    element={<NotificationManagerPage />}
                />
                <Route
                    path={EnumGlobalRoutes.CHAT}
                    element={<ChatPage />}
                />
                <Route
                    path={EnumGlobalRoutes.CHAT + '/:id'}
                    element={<ChatPage />}
                />
                <Route
                    path={EnumGlobalRoutes.SETTINGS}
                    element={<Settings />}
                />
                <Route
                    path={
                        EnumTenantAdminRoutes.TENANT_ADMIN_USER_MANAGEMENT +
                        '/:id'
                    }
                    element={<UserPage />}
                />
                <Route
                    path={EnumGlobalRoutes.SEARCH}
                    element={<SearchPage />}
                />
                <Route
                    path={EnumGlobalRoutes.NOTIFICATIONS}
                    element={<NotificationPage />}
                />
                <Route
                    path="*"
                    element={
                        <Navigate
                            to="/"
                            replace
                        />
                    }
                />
            </Route>
        </Routes>
    </ProtectedRoute>
)

export default TenantAdminRoutes
